import { JobPost } from "../job-posts";
import { User } from "../professionals/professional";

export enum Status {
  PENDING = "pending",
  REJECTED = "rejected",
  SHORTLISTED = "shortlisted",
}

export type JobApplication = {
  _id: string;
  message?: string;
  resume: string;
  status: Status;
  createdBy: User;
  createdAt: string;
  jobPost: JobPost;
};
